export const ROOT_STYLE_INJECT_CLASSNAME = 'root-style-inject';
